export default "__VITE_ASSET__DPVYWyea__"